export default "__VITE_ASSET__BseWBpO4__"